import React, { Component } from "react";
import HelpMark from "../ManageHelp/HelpMark";
import CdpPayCalendar from '../CdpPayCalendar/CdpPayCalendar'
import { UDRDownList } from "../../constants";
import { checkIssues } from "../../redux/modules/downTimeTracker";
import { connect } from "react-redux";
import { lockPrefix, prefix, timeAgo } from "../../utils/pay-utils";
import moment from "moment/moment";
import { Button, Icon } from "semantic-ui-react";
import { parseStartDateFromParams } from "../CdpPayCalendar/utils/dateUtils";

class CdpPay extends Component {
    constructor(props) {
        super(props);
        this.state = { appIsDown: false, saved: props.saved }
    }

    componentDidMount() {
        this.props.dispatch(checkIssues(UDRDownList.CDPPay)).then(res => {
            if (res > 0) this.setState({ appIsDown: true });
        });
    }

    getLastModified = () => {
        const file = this.props.payData?.metadata?.Contents?.find(f => f.Key === this.props.payData?.filename);
        if (!file) return '';
        return <><Icon name="save" color="orange" /> Last updated: <b>{timeAgo(moment(file?.LastModified))}</b> ago</>
    }

    getLatest = () => {
        const startDate = parseStartDateFromParams(this.props.match.params);
        const date = moment(startDate).format('MM-YYYY');
        this.setState({ ...this.state, saved: `${prefix}/${date}.gz` })
    }

    render() {
        const appIsDown = { status: this.state.appIsDown, appDown: UDRDownList.CDPPay };
        return (
            <div className="calendar-container">
                <div className="row">
                    <div className="col-6">
                        <h2 className="float-left">CDP Pay <HelpMark pageId="35" appIsDown={appIsDown} /></h2>
                    </div>
                    <div className="col-6 text-right">
                        {this.props.saved && <span className="mr-3">{this.getLastModified()}</span>}
                        {
                            this.props.payData?.filename?.startsWith(lockPrefix) &&
                            this.props.user.isAdmin &&
                            this.props.user.isPayReportAdmin &&
                            <Button size="mini" onClick={this.getLatest} color="green" content="Show latest" />
                        }
                    </div>
                </div>
                <div className="ui card">
                    <div className="content">
                        <CdpPayCalendar {...this.props} {...this.state} />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    user: state.get('auth').get('user'),
    payData: state.get('payReports').get('billingData')
}))(CdpPay)